"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKAccordionItem = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* jsx-a11y/click-events-have-key-events */
var React = __importStar(require("react"));
var hooks_1 = require("../../../common/hooks");
var components_1 = require("../../../components");
var GKAccordion_1 = require("../GKAccordion");
/**
 * Child component of GKAccordion. Clicking the title toggles the item open/closed.
 */
var GKAccordionItem = function (props) {
    var accordion = React.useContext(GKAccordion_1.GKAccordionContext);
    var uniqueId = (0, hooks_1.usePersistentId2)(props.id);
    var isInOpenSet = accordion.openItems.has(uniqueId);
    var _a = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-accordion-item",
        className: "" + (isInOpenSet ? "child-open" : "child-closed"),
        id: uniqueId,
    }), children = _a.children, isOpen = _a.isOpen, title = _a.title, onClick = _a.onClick, qaProp = _a["data-qa"], componentRenderProps = __rest(_a, ["children", "isOpen", "title", "onClick", "data-qa"]);
    var toggleMe = function () {
        accordion.toggleItem(uniqueId);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    // clean up after unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(function () { return function () { return accordion.toggleItem(uniqueId, false); }; }, []);
    React.useEffect(function () {
        if (isOpen !== undefined) {
            accordion.toggleItem(uniqueId, isOpen);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    return (React.createElement("div", __assign({}, componentRenderProps, { "data-qa": qaProp }),
        React.createElement("div", { className: "gk-accordion-item-header", "data-qa": qaProp + "--header", onClick: toggleMe }, title),
        React.createElement(components_1.GKCollapse, { isOpen: isInOpenSet },
            React.createElement("div", { className: "gk-accordion-item-body", "data-qa": qaProp + "--body" }, children))));
};
exports.GKAccordionItem = GKAccordionItem;
